"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventsUrl = void 0;
var getEventsUrl = function (environmentName) {
    return {
        development: 'https://events.vt.dev',
        staging: 'https://events.vtstaging.com',
        production: 'https://events.varsitytutors.com',
    }[environmentName];
};
exports.getEventsUrl = getEventsUrl;
